export const environment = {
  production: false,
  authApiUrl: 'https://auth.camrslabs.xyz',
  classificationApiUrl: 'https://classification.camrslabs.xyz',
  geocodingApiUrl: 'https://geocoding.camrslabs.xyz',
  propertyApiUrl: 'https://property.camrslabs.xyz',
  chatApiUrl: 'https://chat.camrslabs.xyz',
  affiliateApiUrl: 'https://affiliate.camrslabs.xyz',
  paymentApiUrl: 'https://payment.camrslabs.xyz',
  uploadApiUrl: 'http://localhost:4800',
  oauthBaseUrl: 'https://auth.camrslabs.xyz',
};
